import React from 'react';
import PropTypes from 'prop-types';

import QRCodeStylingOptions from './qr-code-styling-options';
import QRCodeStyling from 'qr-code-styling';

const placeholderImage =
  'data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAEAAAABCAQAAAC1HAwCAAAAC0lEQVR42mP8PhMAAo0BkpQxA1sAAAAASUVORK5CYII=';

// <QrCode> is a class component to allow tests to access the `qrCode` variable via a ref
// to the instance which is not possible with functional components
class QrCode extends React.PureComponent {
  constructor(props) {
    super(props);

    const { width, height } = props;
    this.qrCodeRef = React.createRef();
    this.qrCode = new QRCodeStyling(
      QRCodeStylingOptions(props.url, window.urls.logo, { width, height }),
    );
  }

  componentDidMount() {
    const blobReader = new FileReader();
    const convertPNGToDataURL = (blob) => {
      blobReader.readAsDataURL(blob);
    }; // readAsDataURL will call onload when complete
    const setImgSrcToDataURL = () => {
      if (this.qrCodeRef.current) {
        this.qrCodeRef.current.src = blobReader.result;
      }
    };
    const raiseError = (reason) => {
      console.log(`Failed to extract PNG: ${reason}`);
    };

    blobReader.onload = setImgSrcToDataURL; // when complete, set the reference `img` element to display the result
    this.qrCode.getRawData('png').then(convertPNGToDataURL, raiseError);
    this.qrCode.append(this.qrCodeRef.current);
  }

  render() {
    const { url, width, height } = this.props;

    return (
      <img
        className="mt-2 image-loader__qr-code"
        ref={this.qrCodeRef}
        alt="QR code: open a page to upload photos from your phone"
        data-test-id="mobile-upload-qr-code"
        src={placeholderImage}
        width={width}
        height={height}
        data-url={url}
      />
    );
  }
}

QrCode.propTypes = {
  url: PropTypes.string.isRequired,
  width: PropTypes.number,
  height: PropTypes.number,
};

QrCode.defaultProps = {
  width: 250,
  height: 250,
};

export default QrCode;
